"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _constants = require("../utils/constants");

var _utils = require("../utils/utils");

var _default = {
  title: 'Texts Placement',
  isRelevant: function isRelevant(styleParams) {
    return styleParams.isVertical && styleParams.groupSize === 1 && !styleParams.oneRow;
  },
  type: _constants.INPUT_TYPES.OPTIONS,
  "default": _constants.GALLERY_CONSTS.placements.SHOW_ON_HOVER,
  options: (0, _utils.createOptions)('placements'),
  description: "Choose the the placement of the texts (title and description) relative to the items in the gallery. Note that\n  this option also deals with the hover effects and may overide \"hoveringBehaviour\" when set to anything but \"SHOW_ON_HOVER\".\n  "
};
exports["default"] = _default;